import styled from "styled-components";

interface GutterProps {
  between: "top-bottom" | "left-right";
}

export const SplitGutter = styled.div<GutterProps>`
  ${(props: GutterProps) =>
    props.between === "top-bottom"
      ? `
        cursor: row-resize;
        grid-row: 2;
        grid-column: 1/-1;
        `
      : `
        cursor: col-resize;
        grid-row: 1/-1;
        grid-column: 2;
        `};

  transition: background-color 0.1s ease-in-out;
  /* TODO this color was taken from the navbar, should be replaced with mantine color */
  background-color: #404a52;
  background-repeat: no-repeat;
  background-position: 50%;

  &:hover {
    /* TODO this color was taken from the navbar, should be replaced with mantine color */
    background-color: #c7cbce;
  }
`;
